import React from 'react';
import {TableRowColumn} from 'material-ui/Table';


export default (props) => {

  let onRowClick = (e) => {
    if (props.onRowClick)
    {
      props.onRowClick(e);
    }
    else
    {
      e.stopPropagation();
    }
  }

  const {rowData, ...restProps} = props;

  return (
    <TableRowColumn {...restProps} onClick={onRowClick}>
      <div >{props.children}</div>
    </TableRowColumn>
  )
};



// WEBPACK FOOTER //
// ./src/components/Grid/ClickableRowColumn.jsx